import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component, Prop } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import PageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { ValidationObserver } from 'vee-validate';
import { Holiday } from '@centers/interfaces/holiday';
import { mixins } from 'vue-class-component';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';

@Component({
  name: 'bpc-holiday-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': PageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-std-filter': StdFilter,
    ValidationObserver,
    'bpc-drawer-modal': DrawerModal,
  },
})
export default class HolidayTable extends mixins(AbstractTable) {
  $refs: AbstractTable['$refs'] & {
    stdBulkForm: InstanceType<typeof StdForm> & {
      saveEntity(): void;
    };
  };

  @Prop(String) readonly displayConfigName: string;
  @Prop(String) readonly title: string;
  @Prop(String) readonly subtitle: string;

  public entity: Holiday = null;
  public entityName = 'holiday';
  public pluralEntityName = 'holidays';

  showBulkStoreDrawer: boolean = false;
  keyBulkStore: number = 0;
  savingHoliday: boolean = false;

  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'filtersLoaded',
    'paginationLoaded',
    'orderLoaded',
    'urlParametersLoaded',
  ];

  public customPageActions = {
    bulkStore: {
      activated: false,
      type: 'action',
      icon: 'plus',
      variant: 'success',
      text: 'create_holiday',
      show: true,
      event: 'bulk-store',
      selectElements: false,
      tag: 'right',
      permissions: ['bulk_store'],
    },
  };

  customOnPageAction($event: string) {
    switch ($event) {
      case 'bulk-store':
        this.onBulkStore();
        break;
    }
    console.log('Page Title event >>> ' + $event);
  }

  onBulkStore() {
    this.showBulkStoreDrawer = true;
  }

  onCloseBulkStore() {
    this.showBulkStoreDrawer = false;
    this.keyBulkStore++;
  }

  get bulkStorePath() {
    return `${this.$bpcApiRouteHelper.getEntityPath('holidays')}/bulk-store`;
  }

  onSaveBulkStore() {
    this.$refs.stdBulkForm.saveEntity();
  }

  onCreatedBulkStore() {
    this.savingHoliday = false;
    this.showBulkStoreDrawer = false;
    this.keyBulkStore++;
    this.onFormSaved();
  }

  onSavingHoliday(event) {
    this.savingHoliday = event;
  }

  setEntityAttributesAfterSave() {
    const newEntity = {} as Holiday;
    Object.keys(this.entity).forEach(key => {
      this.$set(newEntity, key, null);
    });

    this.$set(newEntity, 'status', this.entity.status);
    this.$set(newEntity, 'name', this.entity.name);
    this.$set(newEntity, 'day_type', this.entity.day_type);
    this.$set(newEntity, 'date', this.entity.date);
    this.$set(this.$refs.stdForm, 'formModel', newEntity);

    this.showForm = true;
    this.showDrawerSection = true;
  }

  /* Lifecycle hooks */

  // created() { }
  // mounted() {}
  // updated () { }
  // destroyed () { }
}
